import { Pipe, PipeTransform } from "@angular/core";
import { EventData } from "../../providers/event";

@Pipe({
  name: "xls_api",
})
export class XlsApiPipe implements PipeTransform {

  public names = {
    "1-info": "info_1",
    "2-diary": "diary_2",
    "3-streaming": "streaming_3",
    "4-map": "map_4",
    "5-news": "news_5",
    "6-commercial": "commercial_6",
    "7-user-email": "userEmail_7",
    "8-user-code": "userCode_8",
  };

  constructor(
    private eventData: EventData,
  ) { }

  public transform(value: string) {
    return this.names[value] ? this.names[value] : value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/xls-api/xls-api.ts